// extracted by mini-css-extract-plugin
export var component = "Section-module--component--qh1Tf";
export var wrapper = "Section-module--wrapper--f-2bN";